import apiConfig from "../ApiConfig";

export const getLMSModulesApi = async (page = 1, limit = 10) => {
    try {
        const response = await apiConfig.get('/api/lms/modules/', {
            params: {
                page: page,
                limit: limit
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching risks:', error);
        throw error;
    }
};

export const getLMSCustomerModulesApi = async (page = 1, limit = 10, customerId) => {
    try {
        const response = await apiConfig.get(`/api/lms/customer/modules/${customerId}/`, {
            params: {
                page: page,
                limit: limit
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching risks:', error);
        throw error;
    }
};


export const getLMSEndUserModulesApi = async (employeeId) => {
  try {
    if (!employeeId) {
      throw new Error("Employee ID is required for end user LMS modules");
    }

    const response = await apiConfig.get(
      `/api/lms/end-user/modules/${employeeId}/`
    );

    return response;
  } catch (error) {
    console.error("Error fetching end user LMS modules:", error);
    throw error;
  }
};

export const getQuizQuestionsApi = async ({
  moduleId,
  page = 1,
  pageSize = 10,
  role,
  employeeId
}) => {
  const params = {
    page,
    page_size: pageSize,
    role
  };
  if (role === "end_user" && employeeId) {
    params.employee_id = employeeId;
  }

  const response = await apiConfig.get(
    `/api/lms/modules/${moduleId}/quiz/`,
    { params }
  );

  return response.data;
};

export const getModuleAssignToApi = async (moduleId) => {
    try {
        const response = await apiConfig.get(`/api/lms/customer/modules/${moduleId}/assigned-to/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching module assignment:', error);
        throw error;
    }
};

export const assignModuleApi = async (assignmentData) => {
    try {
        const response = await apiConfig.post('/api/lms/customer/modules/assign/', assignmentData);
        return response.data;
    } catch (error) {
        console.error('Error assigning module:', error);
        throw error;
    }
};

/* ── LMS Module CRUD Operations ── */

export const getLMSModuleDetailApi = async (moduleId) => {
    try {
        const response = await apiConfig.get(`/api/lms/modules/${moduleId}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching module detail:', error);
        throw error;
    }
};

export const createLMSModuleApi = async (payload) => {
    try {
        const response = await apiConfig.post('/api/lms/modules/create/', payload);
        return response.data;
    } catch (error) {
        console.error('Error creating LMS module:', error);
        throw error;
    }
};

export const updateLMSModuleApi = async (moduleId, payload) => {
    try {
        const response = await apiConfig.put(`/api/lms/modules/${moduleId}/update/`, payload);
        return response.data;
    } catch (error) {
        console.error('Error updating LMS module:', error);
        throw error;
    }
};

export const deleteLMSModuleApi = async (moduleId) => {
    try {
        const response = await apiConfig.delete(`/api/lms/modules/${moduleId}/delete/`);
        return response.data;
    } catch (error) {
        console.error('Error deleting LMS module:', error);
        throw error;
    }
};

export const uploadLMSBulkApi = async (formData) => {
    try {
        const response = await apiConfig.post('/api/lms/modules/bulk-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading LMS bulk data:', error);
        throw error;
    }
};

export const bulkUploadLMSCombinedApi = async (formData) => {
    try {
        const response = await apiConfig.post('/api/lms/modules/bulk-upload-combined/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading combined LMS data:', error);
        throw error;
    }
};

export const exportLMSDataApi = async () => {
    try {
        const response = await apiConfig.get('/api/lms/modules/export/');
        return response.data;
    } catch (error) {
        console.error('Error exporting LMS data:', error);
        throw error;
    }
};

export const downloadQuizCertificateApi = async ({ employeeId, lmsId, score, userName, moduleTitle }) => {
    try {
        const params = {
            employee_id: employeeId,
            lms_id: lmsId,
        };

        if (typeof score !== 'undefined' && score !== null) {
            params.score = score;
        }
        if (userName) {
            params.user_name = userName;
        }
        if (moduleTitle) {
            params.module_title = moduleTitle;
        }

        const response = await apiConfig.get('/api/lms/certificate/', {
            params,
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error('Error downloading certificate:', error);
        throw error;
    }
};
